// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".stepper_content__3trHe {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}", "",{"version":3,"sources":["webpack://src/components/Stepper/stepper.module.scss"],"names":[],"mappings":"AAEA;EACE,oBAAA;EAAA,aAAA;EACA,0BAAA;MAAA,sBAAA;AADF","sourcesContent":["@import \"../../assets/scss/variables\";\n\n.content {\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": "stepper_content__3trHe"
};
export default ___CSS_LOADER_EXPORT___;
